export interface PaymentEventRow {
  id?: number
  parentPaymentId?: number | null
  amount?: number | string
  whTaxPrice?: number | string
}

export interface PaymentEventFee {
  incomeDocumentPaymentId?: number | string | null
  amount?: number | string
  reason?: number | string
}

export const paymentFeeSettlementAmount = (fees: PaymentEventFee[] = []) =>
  fees.reduce((total, fee) => {
    const amount = Number(fee.amount || 0)
    return total + (Number(fee.reason) === -1 ? amount : -amount)
  }, 0)

export const paymentEventRows = <T extends PaymentEventRow>(payments: T[] = [], parentPaymentId?: number | string | null) => {
  if (parentPaymentId === null || parentPaymentId === undefined) return []
  const parentId = Number(parentPaymentId)
  return payments.filter((payment) =>
    Number(payment.id) === parentId || Number(payment.parentPaymentId || 0) === parentId
  )
}

/** Fees belong to the payment event that owns their payment id. */
export const paymentEventFees = <T extends PaymentEventFee>(fees: T[] = [], payments: PaymentEventRow[] = []) => {
  const paymentIds = new Set(payments.map((payment) => Number(payment.id)).filter(Boolean))
  return fees.filter((fee) => paymentIds.has(Number(fee.incomeDocumentPaymentId)))
}

export const paymentEventTotal = (payments: PaymentEventRow[] = [], fees: PaymentEventFee[] = []) => {
  const paymentTotal = payments.reduce(
    (total, payment) => total + Number(payment.amount || 0) + Number(payment.whTaxPrice || 0),
    0
  )
  const feeSettlementTotal = paymentFeeSettlementAmount(fees)
  return Number((paymentTotal + feeSettlementTotal).toFixed(2))
}

export const paymentRemainingAmount = (
  documentAmount: number | string,
  payments: PaymentEventRow[] = [],
  fees: PaymentEventFee[] = []
) => Number((Number(documentAmount || 0) - paymentEventTotal(payments, fees)).toFixed(2))
